import { useEffect, useState } from "react";
import { Row, Col, Card, ListGroup, ListGroupItem } from "react-bootstrap";
import apiFc from "../../services/APIFc";
import {
  formatearFechaLocal,
  formatearPrecio,
} from "../../functions/Procedimientos";

const Contrarreembolso = () => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    apiFc
      .get(`/web/pdv/contrarembolso/listado`)
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        console.error("Error al cargar los rubros", error);
      });
  };

  useEffect(() => {
    fetchData();
    setLoading(false);
  }, []);

  return (
    <div>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "200px" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      ) : (
        <Row>
          <Col>
            <Card className="overflow-hidden">
              <Card.Header className="pb-1">
                <Card.Title className="mb-2">Contrarembolso</Card.Title>
              </Card.Header>
              <Card.Body className="p-0">
                <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "200px" }}
                    >
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Cargando...</span>
                      </div>
                    </div>
                  ) : (
                    <ListGroup className="projects-list border-0">
                      {data.length > 0 ? (
                        data.map((contrarembolso: any, index: number) => {
                          const recibido =
                            contrarembolso.contrarembolsoEstado !==
                            "Despachado";
                          const colorTexto = recibido
                            ? "text-success"
                            : "text-danger";
                          const badgeColor = recibido
                            ? "badge-success-transparent"
                            : "badge-danger-transparent";
                          const badgeTexto = recibido
                            ? "Recibido"
                            : "Despachado";

                          return (
                            <ListGroupItem
                              key={index}
                              className="list-group-item-action flex-column align-items-start border-bottom-0 border-start-0 border-end-0 border-top"
                            >
                              <div className="d-flex justify-content-between w-100">
                                <div>
                                  <p className="tx-13 font-weight-semibold text-dark mb-1">
                                    Contrarrembolso Nro:{" "}
                                    {contrarembolso.contrarembolsoNumero}
                                  </p>
                                  <div className="text-muted tx-12">
                                    Despacho:{" "}
                                    {formatearFechaLocal(
                                      contrarembolso.fechaDespacho
                                    )}
                                  </div>
                                  <div className="text-muted tx-12">
                                    Recibido:{" "}
                                    {contrarembolso.contrarembolsoFecha
                                      ? formatearFechaLocal(
                                          contrarembolso.contrarembolsoFecha
                                        )
                                      : "Pendiente"}
                                  </div>
                                </div>
                                <div className="text-end d-flex flex-column justify-content-start align-items-end">
                                  <h4
                                    className={`mb-0 font-weight-semibold tx-18 text-end ${colorTexto}`}
                                  >
                                    <span
                                      className={`badge ${badgeColor} text-end`}
                                    >
                                      {formatearPrecio({
                                        valor:
                                          contrarembolso.contrarembolsoImporteRecibido ||
                                          contrarembolso.contrarembolsoImporte,
                                      })}
                                    </span>
                                  </h4>
                                  <span className={`badge mt-1 ${badgeColor}`}>
                                    <span
                                      className={`op-7 font-weight-semibold text-end ${colorTexto}`}
                                    >
                                      {badgeTexto}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </ListGroupItem>
                          );
                        })
                      ) : (
                        <ListGroupItem className="text-center text-muted py-4">
                          Sin recibos
                        </ListGroupItem>
                      )}
                    </ListGroup>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Contrarreembolso;
